import axios from "axios";
import React, { memo, useEffect, useState } from "react";
import { IoIosArrowForward } from "react-icons/io";
import { ENDPOINTS } from "../../../js/api/_config";
import "quill/dist/quill.snow.css";
import { IconCallLogNoData } from "../../../assets/icons/icon-call-log-no-data";

const TrialInformation = ({ trialInfo }) => {
  const [htmlContent, setHtmlContent] = useState();
  const [isLoading, setIsLoading] = useState(true);

  function hasText(str) {
    const plainText = str.replace(/<[^>]*>/g, "").trim();
    return plainText.length > 0;
  }

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const result = await axios.get(
        `${ENDPOINTS.TRIALS.GET_PATIENT_SCREENING}?trialID=${trialInfo?.trialID}`
      );
      setIsLoading(false);
      if (result.data.success) {
        if (result.data.data.value) {
          if (hasText(result.data.data.value)) {
            setHtmlContent(result.data.data.value);
          } else {
            setHtmlContent(null);
          }
        }
      }
    } catch (error) {
    } finally {
      setIsLoading(false); // Set loading to false after the API call
    }
  };

  useEffect(() => {
    if (trialInfo?.trialID) {
      fetchData();
    }
  }, [trialInfo?.trialID]);

  return (
    <div
      className={`h-[calc(100vh-350px)] overflow-y-auto ${
        isLoading ? "flex flex-col flex-1 justify-center items-center" : ""
      }`}
    >
      {isLoading ? (
        <>
          <div className="mini-spinner"></div>
        </>
      ) : htmlContent ? (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      ) : (
        <>
          <div className="text-center w-[100%] mb-5 flex justify-center">
            <IconCallLogNoData />
          </div>
          <p className="text-center w-[100%]">
            No Trial Information available for this patient
          </p>
        </>
      )}
    </div>
  );
};

export default memo(TrialInformation);
